<template>
	<div class="alert-info sticky" role="alert">
		<div class="icon">
			<div class="af-icons-md af-icons-md-alert-info"></div>
		</div>
		<div class="message">
			<p v-output="lang.get('fields.form.formula.feature-disabled', { url: `/feature-disabled/${feature}` })"></p>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['lang'],
	props: {
		feature: {
			type: String,
			required: true,
		},
	},
};
</script>
